import {
  getFirmDetection,
  getNormByDetection,
  // getSpecificatioByName,
  queryRawByName,
  queryVerifyTemplates,
} from "@/api/basicConfig/CPYquality.js";
import { getStationNormByDetection, getStationTest, saveStationTest, saveStationFrequency, getStationFrequency } from "@/api/basicConfig/Sitequality.js";
import { getcompany, getDicType, getListByTypeId, getStationByCompanyId, getUserAutList, get_simple_organization } from "@/api/common.js";
import { getContractList, getContracts } from "@/api/GHnumber/share.js";
import breaDcrumb from "@/components/breadcrumb";
import { getUserInfo } from "@/utils/auth.js";
// import templateSet from "../components/templateSet.vue";
import DueDataStandard from "../components/Raw/DueDataStandard/DueDataStandard.vue";
import QualityTemplate from "../components/Raw/QualityTemplate/QualityTemplate.vue";
import LabelLife from "../components/sitelabelLife.vue";
let oldList = [];
export default {
  components: {
    QualityTemplate, // 质量参数模板
    DueDataStandard, // 交工数据标准
    breaDcrumb,
    LabelLife,
    // templateSet, //模版检验设置
  },
  data() {
    return {
      rIndex: 0, // 原物料检验0 交工数据标准1
      selectTemplateIndex: "", // 所选模板索引
      qualityTemplateConfig: {
        // 站点模板所需参数
        type: 1, //1：原物料；2：混凝土
        stationId: "", // 站点ID
        nameId: "", // 原物料ID/混凝土ID
        specificationId: "", // 原物料规格ID
      },
      UserInfo: "",
      contractTypelist: [
        {
          value: "验收标准",
          id: 0,
        },
        {
          value: "检测频率设置",
          id: 1,
        },
        {
          value: "砼经时预警",
          id: 2,
        },
      ],
      currenindex: 0,
      companyId: "",
      companylist: [],
      showsiteId: "",
      siteId: "",
      siteIdList: [],
      // 左侧导航
      leftList: [
        {
          text: "原物料",
          value: 1,
        },
        {
          text: "强度等级",
          value: 2,
        },
        // {
        //   text: '规范性能等级',
        //   value: 3
        // },
      ],
      leftIndex: 1,
      showleftIndex: 1,
      // 左侧数据
      leftitemList: [],
      showleftitemId: "",
      //模块一
      rightIndex: "",
      showrightIndex: "",
      categoryList: [
        {
          name: "请优先选择对应的原物料或者强度等级",
        },
      ],
      tablenav: [],
      rightitemList: [],
      showrightitemList: [],
      Dialog: false,
      newtablenav: [],
      newrightitemList: [],
      tableLoading: false,
      //模块二
      //合同
      contactId: "0",
      contactIdist: [],
      //类别
      leftId: "",
      leftIdList: [],
      // 频率
      rightId: [],
      rightIdList: [
        {
          itemName: "车",
          id: "1",
          content: "",
        },
        {
          itemName: "吨",
          id: "2",
          content: "",
        },
        // {
        //   itemName: "方",
        //   id: "3",
        //   content: "",
        // },
        {
          itemName: "小时",
          id: "4",
          content: "",
        },
      ],
      rightTotalList: [
        {
          itemName: "车",
          id: "1",
          content: "",
        },
        {
          itemName: "吨",
          id: "2",
          content: "",
        },
        // {
        //   itemName: "方",
        //   id: "3",
        //   content: "",
        // },
        {
          itemName: "小时",
          id: "4",
          content: "",
        },
      ],
      /*存数据*/
      itema: "",
      itemb: "",
      itemc: "",
      /**判断是否是交工数据*/
      signData: false,
      orderNum: "",
      orderStatus: 0,
      production: "",
      productionStatus: 0,
      IntervalState: 5,
      stateList: [
        { belowValue: "", topValue: "", frequencyId: 5, content: "" },
        { belowValue: "", topValue: "", frequencyId: 5, content: "" },
      ],
      /**保存是否存在修改*/
      loading: false,
      showcontactId: "0",
      showleftId: "",
      specification: "",
      specificationList: [],
      rawId: "",
      templateSetDig: false,
      rawList: [],
      templateList: [],
    };
  },
  beforeDestroy() {
    this.timer = null;
  },
  async created() {
    this.UserInfo = await getUserInfo();
    if (this.UserInfo.adminStatus == 1) {
      /**通过typeId为公司类型id查询所有公司 */
      getcompany({ typeId: "19da56b9e85648059e3cf1e7da497da4" }).then(res => {
        this.companylist = res.data;
        this.companyId = res.data[0].id;
        this.queryVerifyTemplates();
        getStationByCompanyId({ id: this.companyId }).then(res => {
          console.log("确认是否有comID", this.siteIdList);
          this.siteIdList = res.data.map(res => ({
            name: res.stationName,
            id: res.id,
          }));
          if (this.siteIdList.length > 0) {
            this.siteId = this.siteIdList[0].id;
            this.showsiteId = this.siteIdList[0].id;
          } else {
            this.siteId = "";
            this.showsiteId = "";
          }
        });
      });
    } else {
      this.companyId = this.UserInfo.companyId;
      this.queryVerifyTemplates();
      this.siteIdList = await getUserAutList(true);
      this.siteId = this.siteIdList[0].id;
      this.showsiteId = this.siteIdList[0].id;
      await this.get_simple_organizationFun(this.siteId);
    }
    this.qualityTemplateConfig.stationId = this.showsiteId; // 默认设置站点ID;
    if (this.siteIdList.length !== 0) {
      this.qualityTemplateConfig.station = this.siteIdList[0].name;
      this.qualityTemplateConfig.comId = this.siteIdList[0].comId;
    }
  },
  watch: {
    /*验收标准，检测频率切换*/
    currenindex() {
      this.initright();
    },
    /*更改站点*/
    siteId() {
      if (this.currenindex == 1) {
        this.clearAll();
      } else {
        this.getTable();
      }
    },
    /*更改公司*/
    async companyId() {
      this.showleftitemId = "";
      this.rightIndex = "";
      this.showrightIndex = "";
      this.categoryList = [
        {
          name: "暂未绑定检测类别",
        },
      ];
      if (this.currenindex == 0) {
        await this.gettightList();
      }
    },
    /*更改原物料或者强度等级*/
    showleftitemId() {
      if (this.currenindex == 0) {
        /**验收标准*/
        this.getNewData();
      } else {
        /**检测频率清空*/
        this.clearAll();
      }
    },
    /*** 原物料或者强度切换后*/
    leftIndex: {
      handler() {
        this.qualityTemplateConfig.specificationId = "";
        this.qualityTemplateConfig.nameId = "";
        //----------------------------------------分割线-------------------------------------
        this.showleftitemId = "";
        this.specification = "";
        if (this.currenindex == 0) {
          /**验收标准清空*/
          this.initright();
        } else {
          /**检测频率清空*/
          this.clearAll();
        }
        switch (this.leftIndex) {
          case 1: {
            getDicType({
              code: "MATname",
            }).then(res => {
              this.leftitemList = [];
              const list = res.data.items.map(res => ({
                id: res.id,
                name: res.itemName,
              }));
              this.leftitemList = list;
            });
            return;
          }
          case 2: {
            getListByTypeId({
              typeId: 1,
            }).then(res => {
              this.leftitemList = res.data;
            });
            return;
          }
          case 3: {
            getListByTypeId({
              typeId: 2,
            }).then(res => {
              this.leftitemList = res.data.filter(res => res.name[0] == "p" || res.name[0] == "P");
            });
            return;
          }
        }
      },
      deep: false, //是否深度监听，true为是，默认为false
      immediate: true, //immediate表示在watch中首次绑定的时候，是否执
    },
    /*右侧检测类别*/
    rightIndex() {
      this.getTable();
    },
    /**合同和验收类捏更改后获取绑定的频率*/
    dateRange() {
      if (this.leftIndex == 3 && this.contactId) {
        this.getStation();
        return;
      }
      if (this.leftIndex == 1 && this.contactId) {
        this.getStation();
        return;
      }
      if (this.contactId && this.leftId && this.leftIndex !== 3 && this.leftIndex !== 1) {
        this.getStation1();
        return;
      }
    },
  },
  computed: {
    dateRange() {
      const contactId = this.contactId;
      const leftId = this.leftId;
      return { contactId, leftId };
    },
  },
  methods: {
    //模版设置点击
    templateSetClick() {
      this.rawList = this.leftitemList;
      this.templateSetDig = true;
    },
    //模板数据
    queryVerifyTemplates() {
      queryVerifyTemplates({ companyId: this.companyId }).then(res => {
        if (res.code === 1001) {
          this.templateList = res.data;
        }
      });
    },
    changeRaw() {
      this.specification = "";
      this.rawId = this.leftitemList.find(item => item.name === this.showleftitemId).id;
      queryRawByName({ name: this.showleftitemId }).then(res => {
        if (res.code === 1001) {
          this.specificationList = res.data;
        }
      });
      if (this.showleftIndex == 2) {
        this.leftId = this.rawId;
      }
      //----------------------分割线（以下为新增内容）--------------------------------
      // 筛选对应模板
      // const obj = {
      //   1: ["水泥","高抗硫酸盐硅酸盐水泥"],
      //   2: '粉煤灰',
      //   3: '矿粉',
      //   4: '复合掺合料',
      //   5: ["机制砂", "天然砂", "机制砂（砂浆专用）","砂浆砂"],
      //   6: '碎石',
      //   7: '泵送剂',
      //   8: ['膨胀剂', '膨胀剂Ⅰ型',"膨胀剂II型"],
      //   9: '硅灰',
      //   10: '聚丙烯纤维',
      // }
      this.qualityTemplateConfig.nameId = this.rawId; // 原物料ID
      this.qualityTemplateConfig.name = this.showleftitemId; // 原物料
      this.qualityTemplateConfig.specificationId = ""; // 重新选择原物料后清空规格id
      this.qualityTemplateConfig.specification = ""; // 重新选择原物料后清空规格
      // for (const key in obj) {
      //   if (typeof obj[key] === 'string' && obj[key] === this.showleftitemId) {
      //     return (this.selectTemplateIndex = key)
      //   } else if (typeof obj[key] === 'object') {
      //     for (let i = 0; i < obj[key].length; i++) {
      //       if (obj[key][i] === this.showleftitemId) {
      //         return (this.selectTemplateIndex = key)
      //       }
      //     }
      //   } else {
      //     this.selectTemplateIndex = ''
      //   }
      // }
      this.selectTemplateIndex = "";
      this.templateList.forEach(item => {
        if (item.rawId == this.rawId && this.companyId == item.companyId) {
          this.selectTemplateIndex = item.templeId + "";
        }
      });
      console.log(this.selectTemplateIndex);
      if (!this.selectTemplateIndex && this.currenindex == 0 && this.showleftIndex == 1) {
        this.$message.warning("提示：当前原物料未配置模板");
      }
    },
    /**通过站点查询公司 */
    async get_simple_organizationFun(id) {
      await get_simple_organization({ id: id }).then(res => {
        this.companyId = res.data?.id || "";
        this.company = res.data?.name || "";
      });
    },
    /*根据公司获取站点*/
    setstationIdlist() {
      this.qualityTemplateConfig.companyId = this.companyId; // 公司ID
      getStationByCompanyId({ id: this.companyId }).then(res => {
        this.siteIdList = res.data.map(res => ({
          name: res.stationName,
          id: res.id,
        }));
        if (this.siteIdList.length > 0) {
          this.siteId = this.siteIdList[0].id;
          this.showsiteId = this.siteIdList[0].id;
        } else {
          this.siteId = "";
          this.showsiteId = "";
        }
      });
      /* 配置站点信息使用nextTick无效 */
      this.timer = setTimeout(() => {
        this.qualityTemplateConfig.stationId = this.siteIdList[0].id;
        this.qualityTemplateConfig.station = this.siteIdList[0].name;
        console.log(this.qualityTemplateConfig);
      }, 500);
    },
    /**验收标准*/
    /**获取检测类别*/
    gettightList() {
      let _this = this;
      let data = new Object();
      data.type = _this.leftIndex;
      data.companyId = _this.companyId;
      if (_this.leftIndex == 1) {
        data.rawId = _this.rawId;
        data.specification = _this.specification;
        if (!_this.specification) return;
      } else {
        data.strengthGradeId = _this.rawId;
      }
      getFirmDetection(data).then(res => {
        if (res.data.length == 0) {
          _this.rightIndex = "";
          _this.showrightIndex = "";
          _this.categoryList = [
            {
              name: "暂未绑定检测类别",
            },
          ];
        } else {
          _this.categoryList = res.data;
          _this.rightIndex = res.data[0].id;
          _this.showrightIndex = res.data[0].id;
        }
      });
    },
    /*获取表数据*/
    getTable() {
      if (this.companyId == "" || this.siteId == "" || this.showleftitemId == "") {
        return;
      }
      this.tableLoading = true;
      let data = new Object();
      data.type = this.leftIndex;
      data.companyId = this.companyId;
      data.stationId = this.siteId;
      data.id = this.rightIndex;
      if (this.leftIndex == 1) {
        data.rawId = this.rawId;
        data.specification = this.specification;
        if (!this.specification) return;
      } else {
        data.strengthGradeId = this.rawId;
      }
      getStationNormByDetection(data).then(res => {
        this.tableLoading = false;
        this.tablenav = res.data?.claim || [];
        this.rightitemList = this.copy(res.data?.list || []);
        this.showrightitemList = this.copy(res.data?.list || []);
        this.tablenav.unshift({
          name: "检测类别",
        });
      });
    },
    /**站点获取验收*/
    async getNewData() {
      if (this.showleftitemId == "") {
        return;
      }
      this.gettightList();
    },
    /*获取公司标准*/
    getnewtable() {
      if (this.companyId == "" || this.siteId == "" || this.showleftitemId == "") {
        this.$message({
          showClose: true,
          message: "警告哦，请选择对应的数据后再获取公司标准",
          type: "warning",
        });
        return;
      }
      let data = new Object();
      data.type = this.leftIndex;
      data.companyId = this.companyId;
      data.id = this.rightIndex;
      data.checkStatus = 2;
      if (this.leftIndex == 1) {
        data.rawId = this.rawId;
        data.specification = this.specification;
        if (!this.specification) return;
      } else {
        data.strengthGradeId = this.rawId;
      }
      getNormByDetection(data).then(res => {
        this.newtablenav = res.data.claim;
        this.newrightitemList = this.copy(res.data.list);
        this.newtablenav.unshift({
          name: "检测类别",
        });
        let name = this.categoryList.find(res => res.id == this.rightIndex)?.name;
        if (name == "交工数据标准") {
          this.signData = true;
        } else {
          this.signData = false;
        }
        this.Dialog = true;
      });
    },
    /*拷贝*/
    copy(list) {
      let str = JSON.stringify(list);
      return JSON.parse(str);
    },
    judge(str) {
      const string = str.split(",");
      if (string.length !== 2) {
        return true;
      }
      if (isNaN(string[0] * 1) || isNaN(string[1] * 1)) {
        return true;
      }
      return false;
    },
    addnbd() {
      let _this = this;
      /*构造数据对象*/
      let station = _this.siteIdList.find(res => res.id == _this.siteId).name;
      function setdata(parameterSettingId, content) {
        this.type = _this.leftIndex;
        this.companyId = _this.companyId;
        this.stationId = _this.siteId;
        this.specification = _this.specification;
        this.parameterSettingId = parameterSettingId;
        this.rawId = _this.rawId;
        this.content = content;
        if (_this.leftIndex != 1) {
          this.strengthGradeId = _this.rawId;
        }
      }
      let arr = [];
      try {
        this.rightitemList.forEach(res => {
          for (let key in res) {
            if (key !== "0") {
              arr.push(new setdata(res[key]?.id, res[key]?.name, res[key]?.lowerLimitValue, res[key]?.upperLimitValue));
              if (res[key]?.type == 3 && res[key]?.symbol.length !== 1) {
                if (this.judge(res[key]?.name)) {
                  throw Error();
                }
              }
            }
          }
        });
      } catch (e) {
        this.$message({
          message: "警告哦，数字为区间是请输入正确格式，如：10,20",
          type: "warning",
        });
        return;
      }
      // this.rightitemList.forEach(res => {
      //   for (let key in res) {
      //     if (key !== '0') {
      //       arr.push(new setdata(res[key]?.id, res[key]?.name))
      //     }
      //   }
      // })
      for (let key in arr) {
        if (arr[key]?.content == "") {
          this.$message({
            message: "请选择要操作的数据项",
            type: "warning",
          });
          return;
        }
      }
      let name = this.leftitemList.find(res => res.name == this.showleftitemId).name;
      let nameType = this.categoryList.find(res => res.id == this.rightIndex).name;
      this.$router.push({
        name: "sign_Sitequality",
        query: {
          tablenav: JSON.stringify(this.tablenav),
          rightitemList: JSON.stringify(this.rightitemList),
          arr: JSON.stringify(arr),
          company: this.company,
          station: station,
          name: name,
          nameType: nameType,
          type: 1,
          specification: this.specification,
        },
      });
    },
    initright() {
      this.rightIndex = "";
      this.showrightIndex = "";
      this.categoryList = [
        {
          name: "请优先选择对应的原物料或者强度等级",
        },
      ];
      this.tablenav = [];
      this.rightitemList = [];
      this.showrightitemList = [];
      this.contactIdist = [];
      this.leftIdList = [];
      this.specification = "";
      this.rawId = "";
      this.showleftitemId = "";
      this.contactId = "0";
      this.leftId = "";
      this.rightId = [];
      this.itema = "";
      this.itemb = "";
      this.itemc = [];
    },
    /*验收频率切换*/
    choose(num) {
      this.currenindex = num;
      if (this.currenindex == 1) {
        this.leftList = [
          {
            text: "原物料",
            value: 1,
          },
          {
            text: "强度等级",
            value: 2,
          },
          // {
          //   text: '规范性能等级',
          //   value: 3,
          // },
        ];
      } else {
        this.leftList.length = 2;
      }
    },
    change(hid, show, value) {
      if (show === "showsiteId") {
        this.qualityTemplateConfig.stationId = value; // 站点ID
        let site = this.siteIdList.find(item => item.id === value);
        this.qualityTemplateConfig.comId = site?.comId; // 公司ID
        this.qualityTemplateConfig.station = site?.name;
      } else if (show === "specification") {
        this.qualityTemplateConfig.specificationId = this.specificationList.find(item => item.specification === this.specification)?.specificationId; // 规格ID
        this.qualityTemplateConfig.specification = this.specification;
      } else if (show === "showleftIndex") this.qualityTemplateConfig.type = value; // type 1：原物料；2：混凝土

      console.log(this.qualityTemplateConfig, 12342);
      //--------------------------------分割线-------------------------------------
      let _this = this;
      if (_this.currenindex == 1) {
        // if (_this.loading) {
        //   _this.$confirm('请保存更改数据,否则数据将会丢失?', '提示', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     cancelButtonClass: 'bottom_all_two',
        //     confirmButtonClass: 'bottom_all',
        //     type: 'warning'
        //   }).then(() => {
        //     _this[show] = _this[hid]
        //     _this.saveStation();

        //   }).catch(() => {
        //     _this[show] = value;
        //     _this[hid] = value;
        //     _this.loading = false;
        //   });
        //   return;
        // }
        _this[show] = value;
        _this[hid] = value;
      } else {
        // if (JSON.stringify(_this.showrightitemList) !== JSON.stringify(_this.rightitemList)) {
        //   _this.$confirm('请保存更改数据,否则数据将会丢失?', '提示', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     cancelButtonClass: 'bottom_all_two',
        //     confirmButtonClass: 'bottom_all',
        //     type: 'warning'
        //   })
        //     .then(() => {
        //       _this[show] = _this[hid]
        //       _this.addnbd();

        //     })
        //     .catch(() => {
        //       _this[show] = value;
        //       _this[hid] = value;
        //     });
        //   return;
        // }
        _this[show] = value;
        _this[hid] = value;
        this.getNewData();
      }
    },

    /**检测频率设置*/
    /**获取合同并清除合同的选中*/
    async getContract() {
      if (this.siteId && this.showleftitemId) {
        if (this.leftIndex === 1) {
          let data = {
            id: this.rawId,
            stations: this.siteId,
            specification: this.specification,
          };
          await getContracts(data).then(res => {
            const newData = res.data.map(item => ({
              ...item,
              name: `${item.contractNo}-${item.supplier}`,
            }));
            this.contactIdist = newData;
            this.contactIdist.splice(0, 0, {
              name: "通用设置",
              contractId: "0",
            });
          });
        } else {
          const params = {
            stationId: this.siteId,
            materialsId: this.rawId,
            materialsType: this.leftIndex === 2 ? "1" : "2",
          };
          await getContractList(params).then(res => {
            const newData = res.data.map(item => ({
              ...item,
              name: `${item.ccContractNo}-${item.enginnerrName}`,
            }));
            this.contactIdist = newData;
            this.contactIdist.splice(0, 0, {
              name: "通用设置",
              contractId: "0",
            });
          });
        }
      } else {
        this.contactIdist = [];
        this.contactIdist.splice(0, 0, { name: "通用设置", contractId: "0" });
      }
      this.contactId = "0";
      this.showcontactId = "";
    },
    /**获取检测类别,并清除选中*/
    async gettightList2() {
      let data = new Object();
      data.type = this.leftIndex;
      data.all = 1;
      data.companyId = this.companyId;
      if (this.leftIndex == 1) {
        data.rawId = this.rawId;
        data.specification = this.specification;
      } else {
        data.strengthGradeId = this.rawId;
      }
      await getFirmDetection(data).then(res => {
        // if (res.data.length == 0 || this.contactIdist.length == 0) {
        //   this.leftIdList = []
        //   this.leftId = ''
        //   this.showleftId = ''
        // } else {
        //   this.leftIdList = res.data
        //   this.leftId = ''
        //   this.showleftId = ''
        // }
        this.leftIdList = res.data;
        this.leftId = "";
        this.showleftId = "";
      });
    },
    /**清空所有数据*/
    async clearAll() {
      let _this = this;
      // await _this.getContract()
      await _this.gettightList2();
      oldList = [];
      _this.rightId = [];
      _this.IntervalState = 5;
      _this.stateList = _this.$options.data().stateList;
      _this.orderStatus = 0;
      _this.orderNum = null;
      _this.productionStatus = 0;
      _this.production = null;
      // _this.specification = ''
    },
    async clearRight() {
      let _this = this;
      oldList = [];
      _this.rightId = [];
      _this.IntervalState = 5;
      _this.stateList = _this.$options.data().stateList;
      _this.orderStatus = 0;
      _this.orderNum = null;
      _this.productionStatus = 0;
      _this.production = null;
    },
    /*获取绑定频率,先获取站点的参数，公司没有则恢复默认*/
    async getStation() {
      let _this = this;
      _this.$data.rightIdList = _this.$options.data().rightIdList;
      if (_this.siteId == "" || _this.companyId == "" || _this.rawId == "") {
        return;
      }
      let data = new Object();
      data.materialsType = _this.leftIndex;
      data.companyId = _this.companyId;
      data.materialsId = _this.rawId;
      data.stationId = _this.siteId;
      data.specification = _this.specification;
      data.contractId = _this.contactId;
      data.qualityDetectionId = _this.leftId;
      getStationTest(data).then(res => {
        if (res.data.length > 0) {
          oldList = JSON.parse(JSON.stringify(res.data));
          /**回显每...*/
          _this.rightId = res.data.filter(res => res.frequencyId * 1 !== 5).map(item => item.frequencyId);
          res.data.forEach(v => {
            _this.rightIdList.forEach(v2 => {
              if (v2.id == v.frequencyId) {
                v2.content = v.content;
                if (v.frequencyCumulant) {
                  const date = new Date(v.frequencyCumulant.hourNum * 1000);
                  const h = date.getHours();
                  _this.rightTotalList[0].content = v.frequencyCumulant.carNum;
                  _this.rightTotalList[1].content = v.frequencyCumulant.tonNum;
                  // _this.rightTotalList[2].content = v.frequencyCumulant.sideNum;
                  // _this.rightTotalList[3].content = h;
                  _this.rightTotalList[2].content = h;
                }
              }
            });
          });
          /**回显检验前置条件*/
          _this.orderStatus = res.data[0].checkOrderNum;
          _this.orderNum = res.data[0].orderNum;
          _this.productionStatus = res.data[0].checkProduction;
          _this.production = res.data[0].production;
          _this.IntervalState = res.data[0].frequencyId * 1;
          /**回显累计生产量*/
          let content = res.data.find(res => res.frequencyId == 5 || res.frequencyId == 6);

          if (!content?.content) {
            _this.stateList = _this.$options.data().stateList;
            return;
          }
          _this.stateList = JSON.parse(content?.content).map(res => ({
            belowValue: "",
            topValue: res.num,
            frequencyId: _this.IntervalState,
            content: res.value,
          }));
        } else {
          _this.clearRight();
        }
      });
    },
    /*获取绑定频率,先获取站点的参数，公司没有则恢复默认 --强盾等级--检测频率*/
    async getStation1() {
      let _this = this;
      _this.$data.rightIdList = _this.$options.data().rightIdList;
      if (_this.siteId == "" || _this.companyId == "" || _this.rawId == "") {
        return;
      }
      let data = new Object();
      data.materialsType = _this.leftIndex;
      data.companyId = _this.companyId;
      data.materialsId = _this.rawId;
      data.stationId = _this.siteId;
      data.specification = _this.specification;
      data.contractId = _this.contactId;
      data.qualityDetectionId = _this.leftId;
      getStationFrequency(data).then(res => {
        if (res.data) {
          oldList = JSON.parse(JSON.stringify(res.data));
          let resData = [res.data];
          /**回显每...*/
          _this.rightId = resData.filter(res => res.frequencyId * 1 !== 5).map(item => item.frequencyId);
          resData.forEach(v => {
            _this.rightIdList.forEach(v2 => {
              if (v2.id == v.frequencyId) {
                v2.content = v.content;
                if (v.frequencyCumulant) {
                  const date = new Date(v.frequencyCumulant.hourNum * 1000);
                  const h = date.getHours();
                  _this.rightTotalList[0].content = v.frequencyCumulant.carNum;
                  _this.rightTotalList[1].content = v.frequencyCumulant.tonNum;
                  _this.rightTotalList[2].content = v.frequencyCumulant.sideNum;
                  _this.rightTotalList[3].content = h;
                }
              }
            });
          });
          /**回显检验前置条件*/
          _this.orderStatus = resData[0].checkOrderNum;
          _this.orderNum = resData[0].orderNum;
          _this.productionStatus = resData[0].checkProduction;
          _this.production = resData[0].production;
          _this.IntervalState = resData[0].frequencyId * 1 || 5;
          /**回显累计生产量*/
          let content = resData.find(res => res.frequencyId == 5 || res.frequencyId == 6);

          if (!content?.content) {
            _this.stateList = _this.$options.data().stateList;
            return;
          }
          _this.stateList = JSON.parse(content?.content).map(res => ({
            belowValue: "",
            topValue: res.num,
            frequencyId: _this.IntervalState,
            content: res.value,
          }));
        } else {
          _this.clearRight();
        }
      });
    },
    changeLoading() {
      if (this.leftIndex == 3 && this.showleftitemId && this.contactId) {
        this.loading = true;
      }
      if (this.showleftitemId && this.leftId && this.leftIndex !== 3 && this.contactId) {
        this.loading = true;
      }
    },
    /*累计生产量的增删*/
    addItem() {
      this.stateList.push({
        belowValue: "",
        topValue: "",
        frequencyId: 5,
        content: "",
      });
    },
    delItem(item, index) {
      if (item.id) {
        item.status = 0;
        return;
      }
      this.stateList.splice(index, 1);
    },
    /**保存*/
    async saveStation() {
      if (this.leftIndex !== 1) {
        this.saveStation1();
        return;
      }
      let _this = this;
      if (!this.showsiteId) {
        this.$message.warning("请选择站点！");
        return;
      }
      function setdata(content, frequencyId, frequency, id) {
        this.id = id;
        this.companyId = _this.companyId;
        this.content = content;
        this.contractId = _this.contactId;
        this.stationId = _this.siteId;
        this.frequency = frequency;
        this.specification = _this.specification;
        this.frequencyId = frequencyId;
        this.materialsId = _this.rawId;
        this.materialsName = _this.leftitemList.find(res => res.name == _this.showleftitemId)?.name;
        this.materialsType = _this.leftIndex;
        this.orderNum = _this.orderNum;
        this.production = _this.production;
        this.qualityDetection = _this.leftIdList.find(res => res.id == _this.leftId)?.name;
        this.qualityDetectionId = _this.leftId;
        this.checkOrderNum = _this.orderStatus;
        this.checkProduction = _this.productionStatus;
      }
      let arr = [];
      _this.rightId.forEach(v => {
        arr.push(new setdata(_this.rightIdList.find(res => res.id == v)?.content, v, _this.rightIdList.find(res => res.id == v)?.itemName, oldList.find(res => res.frequencyId == v)?.id));
      });
      // let content = _this.stateList.map(res => ({
      //   num: Number(res.topValue),
      //   value: res.content,
      // }));
      // arr.push(new setdata(JSON.stringify(content), _this.IntervalState, _this.IntervalState == 5 ? "计划累计量" : "配比累计量", oldList.find(res => res.frequencyId * 1 == this.IntervalState)?.id));
      if (_this.IntervalState == "") {
        _this.$message.warning("请选择累计量类型");
        return;
      }
      if (_this.showleftitemId == "" && !this.showleftitemId) {
        _this.$message.warning("请选择原物料、强度等级或规范性能等级");
        return;
      }
      if (_this.contactId == "") {
        _this.$message.warning("请选择合同");
        return;
      }
      if (_this.leftIndex !== 3 && _this.leftId == "") {
        _this.$message.warning("请选择检验类别");
        return;
      }
      if (oldList.length == 0 && arr.length == 0) {
        _this.$message.warning("请选择检验频率");
        return;
      }
      let allHasData = arr.filter(item => oldList.some(items => item.id == items.id));
      let deleteData = oldList.filter(item => !allHasData.some(items => item.id == items.id));
      deleteData.forEach(item => {
        item.status = 0;
      });
      saveStationTest([...arr, ...deleteData]).then(res => {
        if (res.code * 1 === 1001) {
          _this.$message.success("保存成功");
          _this.getStation();
          _this.loading = false;
        }
      });
    },

    /**强度等级--检测频率-- 保存*/
    async saveStation1() {
      let _this = this;
      if (!this.showsiteId) {
        this.$message.warning("请选择站点！");
        return;
      }
      function setdata(content, frequencyId, frequency) {
        this.companyId = _this.companyId;
        this.content = content;
        this.contractId = _this.contactId;
        this.stationId = _this.siteId;
        this.frequency = frequency;
        this.specification = _this.specification;
        this.frequencyId = frequencyId;
        this.materialsId = _this.rawId;
        this.materialsName = _this.leftitemList.find(res => res.name == _this.showleftitemId)?.name;
        this.materialsType = _this.leftIndex;
        this.orderNum = _this.orderNum;
        this.production = _this.production;
        this.qualityDetection = _this.leftIdList.find(res => res.id == _this.leftId)?.name;
        this.qualityDetectionId = _this.leftId;
        this.checkOrderNum = _this.orderStatus;
        this.checkProduction = _this.productionStatus;
      }
      let contentNull = false
      _this.stateList.forEach(item => {
        if(!item.content){
          contentNull = true
        }
      })
      let arr = {};
      let content = _this.stateList.map(res => ({
        num: Number(res.topValue),
        value: res.content,
      }));
      arr = new setdata(JSON.stringify(content), _this.IntervalState, _this.IntervalState == 5 ? "计划累计量" : "配比累计量");

      if (_this.IntervalState == "") {
        _this.$message.warning("请选择累计量类型");
        return;
      }
      if (_this.showleftitemId == "" && !this.showleftitemId) {
        _this.$message.warning("请选择原物料、强度等级或规范性能等级");
        return;
      }
      if (_this.contactId == "") {
        _this.$message.warning("请选择合同");
        return;
      }
      if (_this.leftIndex !== 3 && _this.leftId == "") {
        _this.$message.warning("请选择检验类别");
        return;
      }
      if (oldList.length == 0 && arr.length == 0) {
        _this.$message.warning("请选择检验频率");
        return;
      }
      if (contentNull) {
        _this.$message.warning("每方检验不能为空");
        return;
      }
      saveStationFrequency(arr).then(res => {
        if (res.code * 1 === 1001) {
          _this.$message.success("保存成功");
          _this.getStation1();
          _this.loading = false;
        }
      });
    },
  },
};
